import { Badge } from "@peer-start/ui/reducate";
import { BadgeCheck, CircleCheck, CircleDot, Play } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { RouteStatus } from "../data/starting-teacher-route.js";

const tones: Record<RouteStatus, string> = {
  active: "bg-primary/10 text-primary",
  started: "bg-muted text-muted-foreground",
  completed: "bg-success text-success-foreground",
  verified: "bg-info text-info-foreground",
};

export function StartingTeacherStatusPill({
  status,
  onPrimary = false,
}: {
  status: RouteStatus | null;
  /** Keeps the Actief pill readable on the filled plum competency card. */
  onPrimary?: boolean;
}) {
  const { t } = useTranslation();
  if (!status) return null;
  const Icon = { active: Play, started: CircleDot, completed: CircleCheck, verified: BadgeCheck }[status];
  const tone = onPrimary && status === "active" ? "bg-primary-foreground text-primary" : tones[status];
  return (
    <Badge
      className={tone}
      variant={status === "verified" ? "info" : status === "completed" ? "success" : "secondary"}
    >
      <Icon aria-hidden="true" className="size-3.5" />
      {t(`startingTeacher.status.${status}`)}
    </Badge>
  );
}
